import { library } from "@fortawesome/fontawesome-svg-core"
import {
    fab,
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCcVisa,
} from "@fortawesome/free-brands-svg-icons"
import {
    faClock as farClock,
    faDotCircle as farDotCircle,
    faPauseCircle as farPauseCircle,
    faPlayCircle as farPlayCircle,
    faStar as farStar,
    faStopCircle as farStopCircle,
} from "@fortawesome/free-regular-svg-icons"
import {
    faAngleDown,
    faAngleUp,
    faArrowDown,
    faArrowLeft,
    faArrowUp,
    faBackspace,
    faBan,
    faBurn,
    faCalendarAlt,
    faCaretDown,
    faCaretUp,
    faChartArea,
    faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleRight,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faCircle,
    faCog,
    faDollarSign,
    faDownload,
    faEdit,
    faEllipsisV,
    faExclamationCircle,
    faExclamationTriangle,
    faFile,
    faFileAlt,
    faFileAudio,
    faFileExcel,
    faFileImage,
    faFilePdf,
    faFileWord,
    faFilter,
    faKeyboard,
    faList,
    faLock,
    faMicrophone,
    faMinus,
    faMinusCircle,
    faPaperPlane,
    faPause,
    faPencilAlt,
    faPhoneAlt,
    faPhoneSlash,
    faPlay,
    faPlus,
    faQuestion,
    faRetweet,
    faSave,
    faSearch,
    faSearchMinus,
    faSearchPlus,
    faShoppingCart,
    faSms,
    faSort,
    faSpinner,
    faStop,
    faSync,
    faSyncAlt,
    faTag,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrashAlt,
    faUndo,
    faUndoAlt,
    faUpload,
    faUser,
    faUsers,
    faVoicemail,
    faWifi,
    faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import PropTypes from "prop-types"
import React from "react"
import {
    batBold,
    batCheck,
    batItalic,
    batMinusCircle,
    batOl,
    batPencil,
    batPlus,
    batSort,
    batSortDown,
    batSortUp,
    batTimes,
    batTrash,
    batUl,
    batVolume,
} from "./misc/IconPack"

library.add(
    fab,
    faPause,
    faPlus,
    faArrowLeft,
    faUser,
    faLock,
    faPencilAlt,
    faFilePdf,
    faSyncAlt,
    faEdit,
    faTrashAlt,
    faMinus,
    faPlay,
    faStop,
    faTimes,
    faTimesCircle,
    faQuestion,
    faChevronCircleRight,
    faChevronCircleDown,
    faChevronDown,
    faFilter,
    faBan,
    faFileWord,
    faSpinner,
    faExclamationTriangle,
    faCheckCircle,
    faSearch,
    faShoppingCart,
    faPhoneSlash,
    faList,
    faUsers,
    faRetweet,
    faSave,
    faDollarSign,
    faCcVisa,
    faCcMastercard,
    faCcDiscover,
    faCcDinersClub,
    faCcJcb,
    faCcAmex,
    faPhoneAlt,
    faSms,
    faCircle,
    faBackspace,
    farClock,
    faTimesCircle,
    farStar,
    farStopCircle,
    farPlayCircle,
    faFileAudio,
    farDotCircle,
    farPauseCircle,
    faFile,
    faFileAlt,
    faFileImage,
    faFileExcel,
    faCog,
    faVoicemail,
    batTrash,
    batPencil,
    batPlus,
    batTimes,
    batCheck,
    batSort,
    batSortUp,
    batSortDown,
    batVolume,
    batMinusCircle,
    batBold,
    batUl,
    batOl,
    batItalic,
    faChartArea,
    faWifi,
    faSort,
    faAngleDown,
    faTrash,
    faSync,
    faKeyboard,
    faCaretDown,
    faDownload,
    faMicrophone,
    faSearchMinus,
    faSearchPlus,
    faChevronLeft,
    faChevronRight,
    faArrowDown,
    faArrowUp,
    faCheck,
    faUpload,
    faMinusCircle,
    faUndo,
    faEllipsisV,
    faAngleUp,
    faBurn,
    faCalendarAlt,
    faPaperPlane,
    faUndoAlt,
    faCaretUp,
    faExclamationCircle,
    faTag,
    faExternalLinkAlt
)

const Icon = props => {
    let style = props.style ? props.style : {}
    if (props.onClick) style.cursor = "pointer"
    let icon = props.icon
    if (props.card) {
        switch (props.card) {
            case "visa":
                icon = ["fab", "cc-visa"]
                break
            case "mastercard":
                icon = ["fab", "cc-mastercard"]
                break
            case "amex":
                icon = ["fab", "cc-amex"]
                break
            case "diners":
                icon = ["fab", "cc-diners-club"]
                break
            default:
                icon = "credit-card"
        }
    }
    return (
        <FontAwesomeIcon
            icon={icon}
            onClick={props.onClick}
            style={style}
            size={props.size}
            color={props.color}
            spin={props.spin}
            pulse={props.pulse}
            title={props.title}
            flip={props.flip}
            rotation={props.rotation}
            transform={props.transform}
        />
    )
}

const IconProp = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.elementType])
Icon.propTypes = {
    icon: IconProp,
    onClick: PropTypes.func,
    style: PropTypes.object,
    size: PropTypes.oneOf(["xs", "lg", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
    color: PropTypes.string,
    spin: PropTypes.bool,
    title: PropTypes.string,
    flip: PropTypes.oneOf(["horizontal", "vertical", "both"]),
}

export default Icon
